import { getJwtString } from '@backoffice-frontend/authentication'
import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'
import cube from '@cubejs-client/core'
import { InstrumentedHttpTransport } from './InstrumentedHttpTransport'

// Same base URL the `useMultitenantCubeApi` endpoint uses. Ridepooling-service-tenant
// cubes (e.g. the line-service assignment data) live on the same API, distinguished by
// the `x-tenant-type` header below, not a separate host.
const localCubeBaseUrl =
  __VITE_CUBE_ENDPOINT_OVERRIDE__ || `http://localhost:${mockServerPort}`

const multitenantDataApiEndpoints: Record<Environment, string> = {
  [Environment.local]: `${localCubeBaseUrl}/multi-tenant-api/v1`,
  [Environment.test]: '',
  [Environment.development]:
    'https://multi-tenant-cube-data-api.insights.dev.moia-group.io/multi-tenant-api/v1',
  [Environment.integration]:
    'https://multi-tenant-cube-data-api.insights.int.moia-group.io/multi-tenant-api/v1',
  [Environment.production]:
    'https://multi-tenant-cube-data-api.insights.prd.moia-group.io/multi-tenant-api/v1',
  [Environment['production.us-east-1']]:
    'https://multi-tenant-cube-data-api.insights.prd.moia-group.io/multi-tenant-api/v1',
}

const getToken = async () => {
  const token = await getJwtString()
  return token ?? ''
}

const cubeApiByTenant = new Map<string, ReturnType<typeof cube>>()

export const getRidepoolingServiceTenantCubeApi = (
  tenant: string,
): ReturnType<typeof cube> => {
  const cached = cubeApiByTenant.get(tenant)
  if (cached) return cached

  const apiUrl = multitenantDataApiEndpoints[ENV]
  const api = cube(getToken, {
    apiUrl,
    transport: new InstrumentedHttpTransport({
      apiUrl,
      headers: {
        'x-tenant': tenant,
        'x-tenant-type': 'ridepooling_service_tenant',
      },
    }),
  })
  cubeApiByTenant.set(tenant, api)
  return api
}
